module.exports = __webpack_public_path__ + "media/images/voice11-570417c42da8b571e70ad5dfc0c097de.jpg";